var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgZoomUsRound(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_105_1680)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.0546 0H5.94539C2.66184 0 0 2.66184 0 5.94539V18.0546C0 21.3382 2.66184 24 5.94539 24H18.0546C21.3382 24 24 21.3382 24 18.0546V5.94539C24 2.66184 21.3382 0 18.0546 0Z",
    fill: "#2D8CFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 8.77418C5 8.34661 5.34662 8 5.77419 8H13.5464C14.6865 8 15.6109 8.92431 15.6109 10.0645V15.6119C15.6109 16.0393 15.2643 16.3861 14.8367 16.3861H7.06453C5.92432 16.3861 5 15.4617 5 14.3215V8.77418Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.2954 10.6361C16.2954 10.4839 16.3626 10.3394 16.4792 10.2413L18.6986 8.37233C19.0343 8.08966 19.5472 8.32828 19.5472 8.76711V15.6821C19.5472 16.1247 19.0268 16.3619 18.6926 16.0717L16.4732 14.1444C16.3603 14.0463 16.2954 13.9041 16.2954 13.7546V10.6361Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_105_1680"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZoomUsRound);
export default __webpack_public_path__ + "static/media/zoom-us-round.28e63cbcef46e7852231b3741ffb6f09.svg";
export { ForwardRef as ReactComponent };